import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./styles.scss";
import { ScrollToTop, Sidebar, Footer } from "./components";
import { AuthContext } from "./contexts/AuthContext";
import { useStateContext } from "./contexts/ContextProvider";
import { messaging } from "./firebase";
import { onMessage } from "firebase/messaging";
import { Box } from "@mui/material";
import {
  Login,
  ProfilUser,
  UbahProfilUser,
  DaftarUser,
  TambahUser,
  UbahUser,
  TutupPeriode,
  TampilSetting,
  UbahSetting,
  TampilGantiPeriode,
  TampilGroupStok,
  TambahGroupStok,
  UbahGroupStok,
  TampilDaftarStok,
  TampilStok,
  TambahStok,
  UbahStok,
  TampilJenisCOA,
  TambahJenisCOA,
  UbahJenisCOA,
  TampilGroupCOA,
  TambahGroupCOA,
  UbahGroupCOA,
  TampilSubGroupCOA,
  TambahSubGroupCOA,
  UbahSubGroupCOA,
  TampilCOA,
  TambahCOA,
  UbahCOA,
  TampilCabang,
  TambahCabang,
  UbahCabang,
  TampilProvinsi,
  TambahProvinsi,
  UbahProvinsi,
  TampilKabupaten,
  TambahKabupaten,
  UbahKabupaten,
  TampilKecamatan,
  TambahKecamatan,
  UbahKecamatan,
  TampilKelurahan,
  TambahKelurahan,
  UbahKelurahan,
  TampilSupplier,
  TambahSupplier,
  UbahSupplier,
  TampilMekanik,
  TambahMekanik,
  UbahMekanik,
  TampilCustomer,
  TambahCustomer,
  UbahCustomer,
  TampilTipe,
  TambahTipe,
  UbahTipe,
  TampilWarna,
  TambahWarna,
  UbahWarna,
  TampilJenisPembayaran,
  TambahJenisPembayaran,
  UbahJenisPembayaran,
  TampilDaftarPembelian,
  TambahPembelian,
  TampilPembelian,
  UbahPembelian,
  TampilDaftarReturPembelian,
  TambahReturPembelian,
  TampilReturPembelian,
  UbahReturPembelian,
  TampilDaftarPembayaranHutang,
  TambahPembayaranHutang,
  TampilPembayaranHutang,
  UbahPembayaranHutang,
  TampilDaftarPenjualan,
  TambahPenjualan,
  TampilPenjualan,
  TampilDaftarPembayaranPiutang,
  TambahPembayaranPiutang,
  TampilPembayaranPiutang,
  UbahPembayaranPiutang,
  TampilDaftarMutasiStok,
  TambahMutasiStok,
  TampilMutasiStok,
  UbahMutasiStok,
  RekalkulasiStok,
  TampilDaftarHasilStockOpname,
  TambahHasilStockOpname,
  TampilHasilStockOpname,
  UbahHasilStockOpname,
  TampilDaftarEntryRacikan,
  TambahEntryRacikan,
  TampilEntryRacikan,
  UbahEntryRacikan,
  UbahPenjualan,
  LaporanPembelian,
  LaporanPenjualanPerHari,
  LaporanPenjualanPerStok,
  LaporanPenjualanPerMekanik,
  LaporanPenjualanPerNota,
  LaporanKonsumen,
  TarikKonsumen,
  LaporanKartuStok,
  LaporanRekapTotalStok,
  LaporanExportStok,
  LaporanSaldoHutang,
  LaporanTotalHutang,
  LaporanKartuHutang,
  LaporanHutangJatuhTempo,
  LaporanPembayaranHutang,
  LaporanPenerimaanKas,
  LaporanKas,
  TampilDaftarKasMasuk,
  TambahKasMasuk,
  TampilKasMasuk,
  UbahKasMasuk,
  TambahKasMasukChild,
  TampilKasMasukChild,
  UbahKasMasukChild,
  TampilDaftarKasKeluar,
  TambahKasKeluar,
  TampilKasKeluar,
  UbahKasKeluar,
  TambahKasKeluarChild,
  TampilKasKeluarChild,
  UbahKasKeluarChild,
  TampilDaftarBankMasuk,
  TambahBankMasuk,
  TampilBankMasuk,
  UbahBankMasuk,
  TambahBankMasukChild,
  TampilBankMasukChild,
  UbahBankMasukChild,
  TampilDaftarBankKeluar,
  TambahBankKeluar,
  TampilBankKeluar,
  UbahBankKeluar,
  TambahBankKeluarChild,
  TampilBankKeluarChild,
  UbahBankKeluarChild,
  Posting,
  Unposting,
  AktivitasBukuBesar,
  NeracaSaldo,
  // LabaRugiRekap,
  LabaRugi,
  // LabaRugiPercobaan,
  Neraca,
  // NeracaPercobaan,
  // ArusKasRekap,
  // Jurnal,
  TampilDaftarJurnalUmum,
  TambahJurnalUmum,
  TampilJurnalUmum,
  UbahJurnalUmum,
  TambahJurnalUmumChild,
  TampilJurnalUmumChild,
  UbahJurnalUmumChild,
  LaporanJurnalUmum,
} from "./pages/index";
import {
  PosBackOfficeDashboard,
  PosCategories,
  PosItems,
  PosSalesTypes,
  PosIngredientCategories,
  PosIngredientLibrary,
  PosRecipes,
  PosTabLibrary,
  PosTabCustom,
  PosTabActivity,
  PosTabInventory,
  PosTabShift,
} from "./pages/POS/PosPages";
import { FaBars } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";

const App = () => {
  const { screenSize, setScreenSize } = useStateContext();
  // const { collapseSidebar } = useProSidebar();
  const { user } = useContext(AuthContext);
  // const [open, setOpen] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  const USERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user) {
      return children;
    }

    return <Navigate to="/login" />;
  };

  const POSAccessRoute = ({ children, access }) => {
    const { user } = useContext(AuthContext);
    if (!user) return <Navigate to="/login" />;
    if (user?.akses?.[access]) return children;
    return <Navigate to="/unauthorized" />;
  };

  const STOKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.stok) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BUKUBESARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bukuBesar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const AREARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.area) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SUPPLIERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.supplier) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const MEKANIKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.mekanik) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const CUSTOMERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.customer) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const TIPERoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.tipe) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const WARNARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.warna) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const JENISPEMBAYARANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.jenisPembayaran) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const CABANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.cabang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const OWNERRoute = ({ children }) => {
    const { user, dispatch } = useContext(AuthContext);

    if (user.tipeUser === "OWNER/DIREKSI") {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const MANAGERRoute = ({ children }) => {
    const { user, dispatch } = useContext(AuthContext);

    if (user.tipeUser === "MANAGER") {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PROFILUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.profilUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SETTINGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.setting) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const DAFTARUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.daftarUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const TUTUPPERIODERoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.tutupPeriode) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const GANTIPERIODERoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.gantiPeriode) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PEMBELIANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pembelian) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const RETURPEMBELIANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.returPembelian) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PEMBAYARANHUTANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pembayaranHutang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PENJUALANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.penjualan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PEMBAYARANPIUTANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pembayaranPiutang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const MUTASISTOKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.mutasiStok) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const REKALKULASISTOKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.rekalkulasiStok) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const HASILSTOCKOPNAMERoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.hasilStockOpname) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const ENTRYRACIKANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.entryRacikan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPENJUALANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPenjualan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANKONSUMENRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanKonsumen) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPEMBELIANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPembelian) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANSTOKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanStok) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANHUTANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanHutang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANKASRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanKas) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KASMASUKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kasMasuk) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KASKELUARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kasKeluar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BANKMASUKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bankMasuk) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BANKKELUARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bankKeluar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const POSTINGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.posting) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const AKTIVITASBUKUBESARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.aktivitasBukuBesar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const NERACASALDORoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.neracaSaldo) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const JURNALRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.jurnal) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const JURNALUMUMRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.jurnalUmum) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LABARUGIREKAPRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.labaRugiRekap) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LABARUGIRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.labaRugi) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const NERACARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.neraca) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const ARUSKASREKAPRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.arusKasRekap) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  useEffect(() => {
    onMessage(messaging, (payload) => {
      // console.log(payload);
      toast(payload.notification.body);
    });

    // const handleResize = () => setScreenSize(window.innerWidth);

    // window.addEventListener("resize", handleResize);

    // handleResize();

    // return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <div className={`app ${toggled ? "toggled" : ""}`}>
        {user && (
          <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
          />
        )}

        <main>
          <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
            <FaBars />
          </div>

          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            {/* POS Back Office */}
            <Route path="/posBackOffice/dashboard" element={<POSAccessRoute access="posBackOfficeDashboard"><PosBackOfficeDashboard /></POSAccessRoute>} />
            <Route path="/posBackOffice/categories" element={<POSAccessRoute access="posCategories"><PosCategories /></POSAccessRoute>} />
            <Route path="/posBackOffice/items" element={<POSAccessRoute access="posItems"><PosItems /></POSAccessRoute>} />
            <Route path="/posBackOffice/salesTypes" element={<POSAccessRoute access="posSalesTypes"><PosSalesTypes /></POSAccessRoute>} />
            <Route path="/posBackOffice/ingredientCategories" element={<POSAccessRoute access="posIngredientCategories"><PosIngredientCategories /></POSAccessRoute>} />
            <Route path="/posBackOffice/ingredients" element={<POSAccessRoute access="posIngredientLibrary"><PosIngredientLibrary /></POSAccessRoute>} />
            <Route path="/posBackOffice/recipes" element={<POSAccessRoute access="posRecipes"><PosRecipes /></POSAccessRoute>} />
            {/* POS Tab */}
            <Route path="/pos/library" element={<POSAccessRoute access="posTabLibrary"><PosTabLibrary /></POSAccessRoute>} />
            <Route path="/pos/custom" element={<POSAccessRoute access="posTabCustom"><PosTabCustom /></POSAccessRoute>} />
            <Route path="/pos/activity" element={<POSAccessRoute access="posTabActivity"><PosTabActivity /></POSAccessRoute>} />
            <Route path="/pos/inventory" element={<POSAccessRoute access="posTabInventory"><PosTabInventory /></POSAccessRoute>} />
            <Route path="/pos/shift" element={<POSAccessRoute access="posTabShift"><PosTabShift /></POSAccessRoute>} />
            {/* Dashboard */}
            {/* Profil User */}
            <Route
              path="/profilUser"
              element={
                <PROFILUSERRoute>
                  <ProfilUser />
                </PROFILUSERRoute>
              }
            />
            <Route
              path="/profilUser/:id/edit"
              element={
                <PROFILUSERRoute>
                  <UbahProfilUser />
                </PROFILUSERRoute>
              }
            />
            {/* Daftar User */}
            <Route
              path="/daftarUser"
              element={
                <DAFTARUSERRoute>
                  <DaftarUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/:id"
              element={
                <DAFTARUSERRoute>
                  <DaftarUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/:id/edit"
              element={
                <DAFTARUSERRoute>
                  <UbahUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/tambahUser"
              element={
                <DAFTARUSERRoute>
                  <TambahUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/tutupPeriode"
              element={
                <TUTUPPERIODERoute>
                  <TutupPeriode />
                </TUTUPPERIODERoute>
              }
            />
            {/* Setting */}
            <Route
              path="/setting"
              element={
                <SETTINGRoute>
                  <TampilSetting />
                </SETTINGRoute>
              }
            />
            <Route
              path="/setting/:id/edit"
              element={
                <SETTINGRoute>
                  <UbahSetting />
                </SETTINGRoute>
              }
            />
            {/* Ganti Periode */}
            <Route
              path="/gantiPeriode"
              element={
                <GANTIPERIODERoute>
                  <TampilGantiPeriode />
                </GANTIPERIODERoute>
              }
            />
            <Route
              path="/gantiPeriode/:id"
              element={
                <GANTIPERIODERoute>
                  <TampilGantiPeriode />
                </GANTIPERIODERoute>
              }
            />
            {/* Group Stok */}
            <Route
              path="/groupStok"
              element={
                <STOKRoute>
                  <TampilGroupStok />
                </STOKRoute>
              }
            />
            <Route
              path="/groupStok/:id"
              element={
                <STOKRoute>
                  <TampilGroupStok />
                </STOKRoute>
              }
            />
            <Route
              path="/groupStok/:id/edit"
              element={
                <STOKRoute>
                  <UbahGroupStok />
                </STOKRoute>
              }
            />
            <Route
              path="/groupStok/tambahGroupStok"
              element={
                <STOKRoute>
                  <TambahGroupStok />
                </STOKRoute>
              }
            />
            {/* Stok */}
            <Route
              path="/stok"
              element={
                <STOKRoute>
                  <TampilDaftarStok />
                </STOKRoute>
              }
            />
            <Route
              path="/stok/:id"
              element={
                <STOKRoute>
                  <TampilStok />
                </STOKRoute>
              }
            />
            <Route
              path="/stok/:id/edit"
              element={
                <STOKRoute>
                  <UbahStok />
                </STOKRoute>
              }
            />
            <Route
              path="/stok/tambahStok"
              element={
                <STOKRoute>
                  <TambahStok />
                </STOKRoute>
              }
            />
            {/* Jenis COA */}
            <Route
              path="/jenisCoa"
              element={
                <BUKUBESARRoute>
                  <TampilJenisCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/jenisCoa/:id"
              element={
                <BUKUBESARRoute>
                  <TampilJenisCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/jenisCoa/:id/edit"
              element={
                <BUKUBESARRoute>
                  <UbahJenisCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/jenisCoa/tambahJenisCoa"
              element={
                <BUKUBESARRoute>
                  <TambahJenisCOA />
                </BUKUBESARRoute>
              }
            />
            {/* Group COA */}
            <Route
              path="/groupCoa"
              element={
                <BUKUBESARRoute>
                  <TampilGroupCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/groupCoa/:id"
              element={
                <BUKUBESARRoute>
                  <TampilGroupCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/groupCoa/:id/edit"
              element={
                <BUKUBESARRoute>
                  <UbahGroupCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/groupCoa/tambahGroupCoa"
              element={
                <BUKUBESARRoute>
                  <TambahGroupCOA />
                </BUKUBESARRoute>
              }
            />
            {/* Sub Group COA */}
            <Route
              path="/subGroupCoa"
              element={
                <BUKUBESARRoute>
                  <TampilSubGroupCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/subGroupCoa/:id"
              element={
                <BUKUBESARRoute>
                  <TampilSubGroupCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/subGroupCoa/:id/edit"
              element={
                <BUKUBESARRoute>
                  <UbahSubGroupCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/subGroupCoa/tambahSubGroupCoa"
              element={
                <BUKUBESARRoute>
                  <TambahSubGroupCOA />
                </BUKUBESARRoute>
              }
            />
            {/*  COA */}
            <Route
              path="/coa"
              element={
                <BUKUBESARRoute>
                  <TampilCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/coa/:id"
              element={
                <BUKUBESARRoute>
                  <TampilCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/coa/:id/edit"
              element={
                <BUKUBESARRoute>
                  <UbahCOA />
                </BUKUBESARRoute>
              }
            />
            <Route
              path="/coa/tambahCoa"
              element={
                <BUKUBESARRoute>
                  <TambahCOA />
                </BUKUBESARRoute>
              }
            />
            {/*  Cabang */}
            {/* <Route
              path="/cabang"
              element={
                <CABANGRoute>
                  <TampilCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/:id"
              element={
                <CABANGRoute>
                  <TampilCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/:id/edit"
              element={
                <CABANGRoute>
                  <UbahCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/tambahCabang"
              element={
                <CABANGRoute>
                  <TambahCabang />
                </CABANGRoute>
              }
            /> */}
            {/*  Provinsi */}
            <Route
              path="/provinsi"
              element={
                <AREARoute>
                  <TampilProvinsi />
                </AREARoute>
              }
            />
            <Route
              path="/provinsi/:id"
              element={
                <AREARoute>
                  <TampilProvinsi />
                </AREARoute>
              }
            />
            <Route
              path="/provinsi/:id/edit"
              element={
                <AREARoute>
                  <UbahProvinsi />
                </AREARoute>
              }
            />
            <Route
              path="/provinsi/tambahProvinsi"
              element={
                <AREARoute>
                  <TambahProvinsi />
                </AREARoute>
              }
            />
            {/*  Kabupaten */}
            <Route
              path="/kabupaten"
              element={
                <AREARoute>
                  <TampilKabupaten />
                </AREARoute>
              }
            />
            <Route
              path="/kabupaten/:id"
              element={
                <AREARoute>
                  <TampilKabupaten />
                </AREARoute>
              }
            />
            <Route
              path="/kabupaten/:id/edit"
              element={
                <AREARoute>
                  <UbahKabupaten />
                </AREARoute>
              }
            />
            <Route
              path="/kabupaten/tambahKabupaten"
              element={
                <AREARoute>
                  <TambahKabupaten />
                </AREARoute>
              }
            />
            {/*  Kecamatan */}
            <Route
              path="/kecamatan"
              element={
                <AREARoute>
                  <TampilKecamatan />
                </AREARoute>
              }
            />
            <Route
              path="/kecamatan/:id"
              element={
                <AREARoute>
                  <TampilKecamatan />
                </AREARoute>
              }
            />
            <Route
              path="/kecamatan/:id/edit"
              element={
                <AREARoute>
                  <UbahKecamatan />
                </AREARoute>
              }
            />
            <Route
              path="/kecamatan/tambahKecamatan"
              element={
                <AREARoute>
                  <TambahKecamatan />
                </AREARoute>
              }
            />
            {/*  Kelurahan */}
            <Route
              path="/kelurahan"
              element={
                <AREARoute>
                  <TampilKelurahan />
                </AREARoute>
              }
            />
            <Route
              path="/kelurahan/:id"
              element={
                <AREARoute>
                  <TampilKelurahan />
                </AREARoute>
              }
            />
            <Route
              path="/kelurahan/:id/edit"
              element={
                <AREARoute>
                  <UbahKelurahan />
                </AREARoute>
              }
            />
            <Route
              path="/kelurahan/tambahKelurahan"
              element={
                <AREARoute>
                  <TambahKelurahan />
                </AREARoute>
              }
            />
            {/*  Supplier */}
            <Route
              path="/supplier"
              element={
                <SUPPLIERRoute>
                  <TampilSupplier />
                </SUPPLIERRoute>
              }
            />
            <Route
              path="/supplier/:id"
              element={
                <SUPPLIERRoute>
                  <TampilSupplier />
                </SUPPLIERRoute>
              }
            />
            <Route
              path="/supplier/:id/edit"
              element={
                <SUPPLIERRoute>
                  <UbahSupplier />
                </SUPPLIERRoute>
              }
            />
            <Route
              path="/supplier/tambahSupplier"
              element={
                <SUPPLIERRoute>
                  <TambahSupplier />
                </SUPPLIERRoute>
              }
            />
            {/*  Mekanik */}
            <Route
              path="/mekanik"
              element={
                <MEKANIKRoute>
                  <TampilMekanik />
                </MEKANIKRoute>
              }
            />
            <Route
              path="/mekanik/:id"
              element={
                <MEKANIKRoute>
                  <TampilMekanik />
                </MEKANIKRoute>
              }
            />
            <Route
              path="/mekanik/:id/edit"
              element={
                <MEKANIKRoute>
                  <UbahMekanik />
                </MEKANIKRoute>
              }
            />
            <Route
              path="/mekanik/tambahMekanik"
              element={
                <MEKANIKRoute>
                  <TambahMekanik />
                </MEKANIKRoute>
              }
            />
            {/*  Customer */}
            <Route
              path="/customer"
              element={
                <CUSTOMERRoute>
                  <TampilCustomer />
                </CUSTOMERRoute>
              }
            />
            <Route
              path="/customer/:id"
              element={
                <CUSTOMERRoute>
                  <TampilCustomer />
                </CUSTOMERRoute>
              }
            />
            <Route
              path="/customer/:id/edit"
              element={
                <CUSTOMERRoute>
                  <UbahCustomer />
                </CUSTOMERRoute>
              }
            />
            {/* <Route
              path="/customer/tambahCustomer"
              element={
                <CUSTOMERRoute>
                  <TambahCustomer />
                </CUSTOMERRoute>
              }
            /> */}
            {/* Tipe */}
            <Route
              path="/tipe"
              element={
                <TIPERoute>
                  <TampilTipe />
                </TIPERoute>
              }
            />
            <Route
              path="/tipe/:id"
              element={
                <TIPERoute>
                  <TampilTipe />
                </TIPERoute>
              }
            />
            <Route
              path="/tipe/:id/edit"
              element={
                <TIPERoute>
                  <UbahTipe />
                </TIPERoute>
              }
            />
            <Route
              path="/tipe/tambahTipe"
              element={
                <TIPERoute>
                  <TambahTipe />
                </TIPERoute>
              }
            />
            {/* Warna */}
            <Route
              path="/warna"
              element={
                <WARNARoute>
                  <TampilWarna />
                </WARNARoute>
              }
            />
            <Route
              path="/warna/:id"
              element={
                <WARNARoute>
                  <TampilWarna />
                </WARNARoute>
              }
            />
            <Route
              path="/warna/:id/edit"
              element={
                <WARNARoute>
                  <UbahWarna />
                </WARNARoute>
              }
            />
            <Route
              path="/warna/tambahWarna"
              element={
                <WARNARoute>
                  <TambahWarna />
                </WARNARoute>
              }
            />
            {/* JenisPembayaran */}
            <Route
              path="/jenisPembayaran"
              element={
                <JENISPEMBAYARANRoute>
                  <TampilJenisPembayaran />
                </JENISPEMBAYARANRoute>
              }
            />
            <Route
              path="/jenisPembayaran/:id"
              element={
                <JENISPEMBAYARANRoute>
                  <TampilJenisPembayaran />
                </JENISPEMBAYARANRoute>
              }
            />
            <Route
              path="/jenisPembayaran/:id/edit"
              element={
                <JENISPEMBAYARANRoute>
                  <UbahJenisPembayaran />
                </JENISPEMBAYARANRoute>
              }
            />
            <Route
              path="/jenisPembayaran/tambahJenisPembayaran"
              element={
                <JENISPEMBAYARANRoute>
                  <TambahJenisPembayaran />
                </JENISPEMBAYARANRoute>
              }
            />
            {/* TRANSAKSI */}
            {/* Pembelian */}
            <Route
              path="/daftarPembelian"
              element={
                <PEMBELIANRoute>
                  <TampilDaftarPembelian />
                </PEMBELIANRoute>
              }
            />
            <Route
              path="/daftarPembelian/pembelian/tambahPembelian"
              element={
                <PEMBELIANRoute>
                  <TambahPembelian />
                </PEMBELIANRoute>
              }
            />
            <Route
              path="/daftarPembelian/pembelian/tambahPembelian/:id"
              element={
                <PEMBELIANRoute>
                  <TambahPembelian />
                </PEMBELIANRoute>
              }
            />
            <Route
              path="/daftarPembelian/pembelian/:id"
              element={
                <PEMBELIANRoute>
                  <TampilPembelian />
                </PEMBELIANRoute>
              }
            />
            <Route
              path="/daftarPembelian/pembelian/:id/edit"
              element={
                <PEMBELIANRoute>
                  <UbahPembelian />
                </PEMBELIANRoute>
              }
            />
            {/* ReturPembelian */}
            <Route
              path="/daftarReturPembelian"
              element={
                <PEMBELIANRoute>
                  <TampilDaftarReturPembelian />
                </PEMBELIANRoute>
              }
            />
            <Route
              path="/daftarReturPembelian/returPembelian/tambahReturPembelian"
              element={
                <RETURPEMBELIANRoute>
                  <TambahReturPembelian />
                </RETURPEMBELIANRoute>
              }
            />
            <Route
              path="/daftarReturPembelian/returPembelian/tambahReturPembelian/:id"
              element={
                <RETURPEMBELIANRoute>
                  <TambahReturPembelian />
                </RETURPEMBELIANRoute>
              }
            />
            <Route
              path="/daftarReturPembelian/returPembelian/:id"
              element={
                <RETURPEMBELIANRoute>
                  <TampilReturPembelian />
                </RETURPEMBELIANRoute>
              }
            />
            <Route
              path="/daftarReturPembelian/returPembelian/:id/edit"
              element={
                <RETURPEMBELIANRoute>
                  <UbahReturPembelian />
                </RETURPEMBELIANRoute>
              }
            />
            {/* Pembayaran Hutang */}
            <Route
              path="/daftarPembayaranHutang"
              element={
                <PEMBAYARANHUTANGRoute>
                  <TampilDaftarPembayaranHutang />
                </PEMBAYARANHUTANGRoute>
              }
            />
            <Route
              path="/daftarPembayaranHutang/pembayaranHutang/tambahPembayaranHutang"
              element={
                <PEMBAYARANHUTANGRoute>
                  <TambahPembayaranHutang />
                </PEMBAYARANHUTANGRoute>
              }
            />
            <Route
              path="/daftarPembayaranHutang/pembayaranHutang/:id"
              element={
                <PEMBAYARANHUTANGRoute>
                  <TampilPembayaranHutang />
                </PEMBAYARANHUTANGRoute>
              }
            />
            <Route
              path="/daftarPembayaranHutang/pembayaranHutang/:id/edit"
              element={
                <PEMBAYARANHUTANGRoute>
                  <UbahPembayaranHutang />
                </PEMBAYARANHUTANGRoute>
              }
            />
            {/* Penjualan */}
            <Route
              path="/daftarPenjualan"
              element={
                <PENJUALANRoute>
                  <TampilDaftarPenjualan />
                </PENJUALANRoute>
              }
            />
            <Route
              path="/daftarPenjualan/penjualan/tambahPenjualan"
              element={
                <PENJUALANRoute>
                  <TambahPenjualan />
                </PENJUALANRoute>
              }
            />
            <Route
              path="/daftarPenjualan/penjualan/tambahPenjualan/:id"
              element={
                <PENJUALANRoute>
                  <TambahPenjualan />
                </PENJUALANRoute>
              }
            />
            <Route
              path="/daftarPenjualan/penjualan/:id"
              element={
                <PENJUALANRoute>
                  <TampilPenjualan />
                </PENJUALANRoute>
              }
            />
            <Route
              path="/daftarPenjualan/penjualan/:id/edit"
              element={
                <PENJUALANRoute>
                  <UbahPenjualan />
                </PENJUALANRoute>
              }
            />
            {/* Penerimaan Piutang */}
            <Route
              path="/daftarPembayaranPiutang"
              element={
                <PEMBAYARANPIUTANGRoute>
                  <TampilDaftarPembayaranPiutang />
                </PEMBAYARANPIUTANGRoute>
              }
            />
            <Route
              path="/daftarPembayaranPiutang/pembayaranPiutang/tambahPembayaranPiutang"
              element={
                <PEMBAYARANPIUTANGRoute>
                  <TambahPembayaranPiutang />
                </PEMBAYARANPIUTANGRoute>
              }
            />
            <Route
              path="/daftarPembayaranPiutang/pembayaranPiutang/:id"
              element={
                <PEMBAYARANPIUTANGRoute>
                  <TampilPembayaranPiutang />
                </PEMBAYARANPIUTANGRoute>
              }
            />
            <Route
              path="/daftarPembayaranPiutang/pembayaranPiutang/:id/edit"
              element={
                <PEMBAYARANPIUTANGRoute>
                  <UbahPembayaranPiutang />
                </PEMBAYARANPIUTANGRoute>
              }
            />
            {/* Mutasi Stok */}
            <Route
              path="/daftarMutasiStok"
              element={
                <MUTASISTOKRoute>
                  <TampilDaftarMutasiStok />
                </MUTASISTOKRoute>
              }
            />
            <Route
              path="/daftarMutasiStok/mutasiStok/tambahMutasiStok"
              element={
                <MUTASISTOKRoute>
                  <TambahMutasiStok />
                </MUTASISTOKRoute>
              }
            />
            <Route
              path="/daftarMutasiStok/mutasiStok/tambahMutasiStok/:id"
              element={
                <MUTASISTOKRoute>
                  <TambahMutasiStok />
                </MUTASISTOKRoute>
              }
            />
            <Route
              path="/daftarMutasiStok/mutasiStok/:id"
              element={
                <MUTASISTOKRoute>
                  <TampilMutasiStok />
                </MUTASISTOKRoute>
              }
            />
            <Route
              path="/daftarMutasiStok/mutasiStok/:id/edit"
              element={
                <MUTASISTOKRoute>
                  <UbahMutasiStok />
                </MUTASISTOKRoute>
              }
            />
            {/* Rekalkulasi Stok */}
            <Route
              path="/rekalkulasiStok"
              element={
                <REKALKULASISTOKRoute>
                  <RekalkulasiStok />
                </REKALKULASISTOKRoute>
              }
            />
            {/* Hasil Stock Opname */}
            <Route
              path="/daftarHasilStockOpname"
              element={
                <HASILSTOCKOPNAMERoute>
                  <TampilDaftarHasilStockOpname />
                </HASILSTOCKOPNAMERoute>
              }
            />
            <Route
              path="/daftarHasilStockOpname/hasilStockOpname/tambah"
              element={
                <HASILSTOCKOPNAMERoute>
                  <TambahHasilStockOpname />
                </HASILSTOCKOPNAMERoute>
              }
            />
            <Route
              path="/daftarHasilStockOpname/hasilStockOpname/:id"
              element={
                <HASILSTOCKOPNAMERoute>
                  <TampilHasilStockOpname />
                </HASILSTOCKOPNAMERoute>
              }
            />
            <Route
              path="/daftarHasilStockOpname/hasilStockOpname/:id/edit"
              element={
                <HASILSTOCKOPNAMERoute>
                  <UbahHasilStockOpname />
                </HASILSTOCKOPNAMERoute>
              }
            />
            {/* Entry Racikan */}
            <Route
              path="/daftarEntryRacikan"
              element={
                <ENTRYRACIKANRoute>
                  <TampilDaftarEntryRacikan />
                </ENTRYRACIKANRoute>
              }
            />
            <Route
              path="/daftarEntryRacikan/entryRacikan/tambah"
              element={
                <ENTRYRACIKANRoute>
                  <TambahEntryRacikan />
                </ENTRYRACIKANRoute>
              }
            />
            <Route
              path="/daftarEntryRacikan/entryRacikan/:id"
              element={
                <ENTRYRACIKANRoute>
                  <TampilEntryRacikan />
                </ENTRYRACIKANRoute>
              }
            />
            <Route
              path="/daftarEntryRacikan/entryRacikan/:id/edit"
              element={
                <ENTRYRACIKANRoute>
                  <UbahEntryRacikan />
                </ENTRYRACIKANRoute>
              }
            />
            {/* LAPORAN */}
            {/* Laporan Pembelian */}
            <Route
              path="/laporanPembelian"
              element={
                <LAPORANPEMBELIANRoute>
                  <LaporanPembelian />
                </LAPORANPEMBELIANRoute>
              }
            />
            {/* Laporan Penjualan */}
            <Route
              path="/laporanPenjualanPerHari"
              element={
                <LAPORANPENJUALANRoute>
                  <LaporanPenjualanPerHari />
                </LAPORANPENJUALANRoute>
              }
            />
            <Route
              path="/laporanPenjualanPerStok"
              element={
                <LAPORANPENJUALANRoute>
                  <LaporanPenjualanPerStok />
                </LAPORANPENJUALANRoute>
              }
            />
            <Route
              path="/laporanPenjualanPerMekanik"
              element={
                <LAPORANPENJUALANRoute>
                  <LaporanPenjualanPerMekanik />
                </LAPORANPENJUALANRoute>
              }
            />
            <Route
              path="/laporanPenjualanPerNota"
              element={
                <LAPORANPENJUALANRoute>
                  <LaporanPenjualanPerNota />
                </LAPORANPENJUALANRoute>
              }
            />
            <Route
              path="/laporanKonsumen"
              element={
                <LAPORANKONSUMENRoute>
                  <LaporanKonsumen />
                </LAPORANKONSUMENRoute>
              }
            />
            <Route
              path="/tarikKonsumen"
              element={
                <LAPORANKONSUMENRoute>
                  <TarikKonsumen />
                </LAPORANKONSUMENRoute>
              }
            />
            {/* Laporan Stok */}
            <Route
              path="/laporanStokKartuStok"
              element={
                <LAPORANSTOKRoute>
                  <LaporanKartuStok />
                </LAPORANSTOKRoute>
              }
            />
            <Route
              path="/laporanStokRekapTotalStok"
              element={
                <LAPORANSTOKRoute>
                  <LaporanRekapTotalStok />
                </LAPORANSTOKRoute>
              }
            />
            <Route
              path="/laporanExportStok"
              element={
                <LAPORANSTOKRoute>
                  <LaporanExportStok />
                </LAPORANSTOKRoute>
              }
            />
            {/* Laporan Hutang */}
            <Route
              path="/laporanSaldoHutang"
              element={
                <LAPORANHUTANGRoute>
                  <LaporanSaldoHutang />
                </LAPORANHUTANGRoute>
              }
            />
            <Route
              path="/laporanTotalHutang"
              element={
                <LAPORANHUTANGRoute>
                  <LaporanTotalHutang />
                </LAPORANHUTANGRoute>
              }
            />
            <Route
              path="/laporanKartuHutang"
              element={
                <LAPORANHUTANGRoute>
                  <LaporanKartuHutang />
                </LAPORANHUTANGRoute>
              }
            />
            <Route
              path="/laporanHutangJatuhTempo"
              element={
                <LAPORANHUTANGRoute>
                  <LaporanHutangJatuhTempo />
                </LAPORANHUTANGRoute>
              }
            />
            <Route
              path="/laporanPembayaranHutang"
              element={
                <LAPORANHUTANGRoute>
                  <LaporanPembayaranHutang />
                </LAPORANHUTANGRoute>
              }
            />
            {/* Laporan Kas */}
            <Route
              path="/laporanPenerimaanKas"
              element={
                <LAPORANKASRoute>
                  <LaporanPenerimaanKas />
                </LAPORANKASRoute>
              }
            />
            <Route
              path="/laporanKas"
              element={
                <LAPORANKASRoute>
                  <LaporanKas />
                </LAPORANKASRoute>
              }
            />
            {/* FINANCE */}
            {/* Kas Masuk */}
            <Route
              path="/daftarKasMasuk"
              element={
                <KASMASUKRoute>
                  <TampilDaftarKasMasuk />
                </KASMASUKRoute>
              }
            />
            <Route
              path="/daftarKasMasuk/kasMasuk/tambahKasMasuk"
              element={
                <KASMASUKRoute>
                  <TambahKasMasuk />
                </KASMASUKRoute>
              }
            />
            <Route
              path="/daftarKasMasuk/kasMasuk/:id"
              element={
                <KASMASUKRoute>
                  <TampilKasMasuk />
                </KASMASUKRoute>
              }
            />
            <Route
              path="/daftarKasMasuk/kasMasuk/:id/edit"
              element={
                <KASMASUKRoute>
                  <UbahKasMasuk />
                </KASMASUKRoute>
              }
            />
            <Route
              path="/daftarKasMasuk/kasMasuk/:id/tambahKasMasukChild"
              element={
                <KASMASUKRoute>
                  <TambahKasMasukChild />
                </KASMASUKRoute>
              }
            />
            <Route
              path="/daftarKasMasuk/kasMasuk/:id/:idKasMasukChild"
              element={
                <KASMASUKRoute>
                  <TampilKasMasukChild />
                </KASMASUKRoute>
              }
            />
            <Route
              path="/daftarKasMasuk/kasMasuk/:id/:idKasMasukChild/edit"
              element={
                <KASMASUKRoute>
                  <UbahKasMasukChild />
                </KASMASUKRoute>
              }
            />
            {/* Kas Keluar */}
            <Route
              path="/daftarKasKeluar"
              element={
                <KASKELUARRoute>
                  <TampilDaftarKasKeluar />
                </KASKELUARRoute>
              }
            />
            <Route
              path="/daftarKasKeluar/kasKeluar/tambahKasKeluar"
              element={
                <KASKELUARRoute>
                  <TambahKasKeluar />
                </KASKELUARRoute>
              }
            />
            <Route
              path="/daftarKasKeluar/kasKeluar/:id"
              element={
                <KASKELUARRoute>
                  <TampilKasKeluar />
                </KASKELUARRoute>
              }
            />
            <Route
              path="/daftarKasKeluar/kasKeluar/:id/edit"
              element={
                <KASKELUARRoute>
                  <UbahKasKeluar />
                </KASKELUARRoute>
              }
            />
            <Route
              path="/daftarKasKeluar/kasKeluar/:id/tambahKasKeluarChild"
              element={
                <KASKELUARRoute>
                  <TambahKasKeluarChild />
                </KASKELUARRoute>
              }
            />
            <Route
              path="/daftarKasKeluar/kasKeluar/:id/:idKasKeluarChild"
              element={
                <KASKELUARRoute>
                  <TampilKasKeluarChild />
                </KASKELUARRoute>
              }
            />
            <Route
              path="/daftarKasKeluar/kasKeluar/:id/:idKasKeluarChild/edit"
              element={
                <KASKELUARRoute>
                  <UbahKasKeluarChild />
                </KASKELUARRoute>
              }
            />
            {/* Bank Masuk */}
            <Route
              path="/daftarBankMasuk"
              element={
                <BANKMASUKRoute>
                  <TampilDaftarBankMasuk />
                </BANKMASUKRoute>
              }
            />
            <Route
              path="/daftarBankMasuk/bankMasuk/tambahBankMasuk"
              element={
                <BANKMASUKRoute>
                  <TambahBankMasuk />
                </BANKMASUKRoute>
              }
            />
            <Route
              path="/daftarBankMasuk/bankMasuk/:id"
              element={
                <BANKMASUKRoute>
                  <TampilBankMasuk />
                </BANKMASUKRoute>
              }
            />
            <Route
              path="/daftarBankMasuk/bankMasuk/:id/edit"
              element={
                <BANKMASUKRoute>
                  <UbahBankMasuk />
                </BANKMASUKRoute>
              }
            />
            <Route
              path="/daftarBankMasuk/bankMasuk/:id/tambahBankMasukChild"
              element={
                <BANKMASUKRoute>
                  <TambahBankMasukChild />
                </BANKMASUKRoute>
              }
            />
            <Route
              path="/daftarBankMasuk/bankMasuk/:id/:idBankMasukChild"
              element={
                <BANKMASUKRoute>
                  <TampilBankMasukChild />
                </BANKMASUKRoute>
              }
            />
            <Route
              path="/daftarBankMasuk/bankMasuk/:id/:idBankMasukChild/edit"
              element={
                <BANKMASUKRoute>
                  <UbahBankMasukChild />
                </BANKMASUKRoute>
              }
            />
            {/* Bank Keluar */}
            <Route
              path="/daftarBankKeluar"
              element={
                <BANKKELUARRoute>
                  <TampilDaftarBankKeluar />
                </BANKKELUARRoute>
              }
            />
            <Route
              path="/daftarBankKeluar/bankKeluar/tambahBankKeluar"
              element={
                <BANKKELUARRoute>
                  <TambahBankKeluar />
                </BANKKELUARRoute>
              }
            />
            <Route
              path="/daftarBankKeluar/bankKeluar/:id"
              element={
                <BANKKELUARRoute>
                  <TampilBankKeluar />
                </BANKKELUARRoute>
              }
            />
            <Route
              path="/daftarBankKeluar/bankKeluar/:id/edit"
              element={
                <BANKKELUARRoute>
                  <UbahBankKeluar />
                </BANKKELUARRoute>
              }
            />
            <Route
              path="/daftarBankKeluar/bankKeluar/:id/tambahBankKeluarChild"
              element={
                <BANKKELUARRoute>
                  <TambahBankKeluarChild />
                </BANKKELUARRoute>
              }
            />
            <Route
              path="/daftarBankKeluar/bankKeluar/:id/:idBankKeluarChild"
              element={
                <BANKKELUARRoute>
                  <TampilBankKeluarChild />
                </BANKKELUARRoute>
              }
            />
            <Route
              path="/daftarBankKeluar/bankKeluar/:id/:idBankKeluarChild/edit"
              element={
                <BANKKELUARRoute>
                  <UbahBankKeluarChild />
                </BANKKELUARRoute>
              }
            />
            {/* Posting */}
            <Route
              path="/posting"
              element={
                <POSTINGRoute>
                  <Posting />
                </POSTINGRoute>
              }
            />
            <Route
              path="/unposting"
              element={
                <POSTINGRoute>
                  <Unposting />
                </POSTINGRoute>
              }
            />
            <Route
              path="/aktivitasBukuBesar"
              element={
                <AKTIVITASBUKUBESARRoute>
                  <AktivitasBukuBesar />
                </AKTIVITASBUKUBESARRoute>
              }
            />
            <Route
              path="/neracaSaldo"
              element={
                <NERACASALDORoute>
                  <NeracaSaldo />
                </NERACASALDORoute>
              }
            />
            {/* <Route
              path="/jurnal"
              element={
                <JURNALRoute>
                  <Jurnal />
                </JURNALRoute>
              }
            /> */}
            {/* <Route
              path="/labaRugiRekap"
              element={
                <LABARUGIREKAPRoute>
                  <LabaRugiRekap />
                </LABARUGIREKAPRoute>
              }
            /> */}
            <Route
              path="/labaRugi"
              element={
                <LABARUGIRoute>
                  <LabaRugi />
                </LABARUGIRoute>
              }
            />
            {/* <Route
              path="/labaRugiPercobaan"
              element={
                <LABARUGIRoute>
                  <LabaRugiPercobaan />
                </LABARUGIRoute>
              }
            /> */}
            <Route
              path="/neraca"
              element={
                <NERACARoute>
                  <Neraca />
                </NERACARoute>
              }
            />
            {/* <Route
              path="/neracaPercobaan"
              element={
                <NERACARoute>
                  <NeracaPercobaan />
                </NERACARoute>
              }
            /> */}
            {/* <Route
              path="/arusKasRekap"
              element={
                <ARUSKASREKAPRoute>
                  <ArusKasRekap />
                </ARUSKASREKAPRoute>
              }
            /> */}
            {/* Jurnal Umum */}
            <Route
              path="/daftarJurnalUmum"
              element={
                <JURNALUMUMRoute>
                  <TampilDaftarJurnalUmum />
                </JURNALUMUMRoute>
              }
            />
            <Route
              path="/daftarJurnalUmum/jurnalUmum/tambahJurnalUmum"
              element={
                <JURNALUMUMRoute>
                  <TambahJurnalUmum />
                </JURNALUMUMRoute>
              }
            />
            <Route
              path="/daftarJurnalUmum/jurnalUmum/:id"
              element={
                <JURNALUMUMRoute>
                  <TampilJurnalUmum />
                </JURNALUMUMRoute>
              }
            />
            <Route
              path="/daftarJurnalUmum/jurnalUmum/:id/edit"
              element={
                <JURNALUMUMRoute>
                  <UbahJurnalUmum />
                </JURNALUMUMRoute>
              }
            />
            {/* Jurnal Umum Child */}
            <Route
              path="/daftarJurnalUmum/jurnalUmum/:id/tambahJurnalUmumChild"
              element={
                <JURNALUMUMRoute>
                  <TambahJurnalUmumChild />
                </JURNALUMUMRoute>
              }
            />
            <Route
              path="/daftarJurnalUmum/jurnalUmum/:id/:idJurnalUmumChild"
              element={
                <JURNALUMUMRoute>
                  <TampilJurnalUmumChild />
                </JURNALUMUMRoute>
              }
            />
            <Route
              path="/daftarJurnalUmum/jurnalUmum/:id/:idJurnalUmumChild/edit"
              element={
                <JURNALUMUMRoute>
                  <UbahJurnalUmumChild />
                </JURNALUMUMRoute>
              }
            />
            {/* Laporan Jurnal Umum */}
            <Route
              path="/laporanJurnalUmum"
              element={
                <JURNALUMUMRoute>
                  <LaporanJurnalUmum />
                </JURNALUMUMRoute>
              }
            />
          </Routes>
          <Footer />
        </main>
      </div>
    </>
  );
};

export default App;
